import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from './ui/card';
import { Sparkles, Award, Zap, Heart } from 'lucide-react';

const WhyUsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-gradient-to-br from-orange-100 via-pink-100 to-rose-200">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('why.title').split(' ').map((word, i) => {
              const highlight = ['Love', 'Us', 'adorent', 'aman', 'amano'];
              return highlight.includes(word) ? 
                <span key={i} className="bg-gradient-to-r from-purple-600 via-violet-500 to-fuchsia-500 bg-clip-text text-transparent">{word} </span> : 
                word + ' ';
            })}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <Card className="border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
            <CardContent className="p-8">
              <div className="w-16 h-16 mb-6 rounded-2xl bg-gradient-to-br from-purple-500 via-violet-400 to-fuchsia-400 flex items-center justify-center">
                <Award className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('why.quality')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('why.qualityDesc')}
              </p>
            </CardContent>
          </Card>

          <Card className="border-2 border-cyan-100 hover:border-cyan-300 transition-all hover:shadow-lg">
            <CardContent className="p-8">
              <div className="w-16 h-16 mb-6 rounded-2xl bg-gradient-to-br from-cyan-500 to-teal-400 flex items-center justify-center">
                <Sparkles className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('why.personalization')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('why.personalizationDesc')}
              </p>
            </CardContent>
          </Card>

          <Card className="border-2 border-teal-100 hover:border-teal-300 transition-all hover:shadow-lg">
            <CardContent className="p-8">
              <div className="w-16 h-16 mb-6 rounded-2xl bg-gradient-to-br from-teal-500 to-emerald-400 flex items-center justify-center">
                <Zap className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('why.speed')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('why.speedDesc')}
              </p>
            </CardContent>
          </Card>

          <Card className="border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
            <CardContent className="p-8">
              <div className="w-16 h-16 mb-6 rounded-2xl bg-gradient-to-br from-pink-500 to-rose-400 flex items-center justify-center">
                <Heart className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('why.unique')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('why.uniqueDesc')}
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Stats Section */}
        <div className="mt-16">
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
              {t('artists.title').split(' ').map((word, i) => {
                const highlight = ['Multilingual', 'multilingues', 'multilingües'];
                return highlight.includes(word) ? 
                  <span key={i} className="bg-gradient-to-r from-purple-600 via-violet-500 to-fuchsia-500 bg-clip-text text-transparent">{word} </span> : 
                  word + ' ';
              })}
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              {t('artists.description')}
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 rounded-2xl section-wrapper border-2 border-blue-100">
              <div className="text-4xl font-bold bg-gradient-to-r from-purple-600 via-violet-500 to-fuchsia-500 bg-clip-text text-transparent mb-2">
                100%
              </div>
              <p className="text-gray-700 font-medium">{t('artists.stat1')}</p>
            </div>
            <div className="text-center p-6 rounded-2xl section-wrapper border-2 border-cyan-100">
              <div className="text-4xl font-bold bg-gradient-to-r from-cyan-600 to-teal-500 bg-clip-text text-transparent mb-2">
                +10,000
              </div>
              <p className="text-gray-700 font-medium">{t('artists.stat2')}</p>
            </div>
            <div className="text-center p-6 rounded-2xl section-wrapper border-2 border-teal-100">
              <div className="text-4xl font-bold bg-gradient-to-r from-teal-600 to-emerald-500 bg-clip-text text-transparent mb-2">
                +15 Years
              </div>
              <p className="text-gray-700 font-medium">{t('artists.stat3')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
